module.exports = __webpack_public_path__ + "0afa8d3d56361993f48edf158194d4ff.jpg";